import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import WrapperPartnerMain from '../../components/wrappers/WrapperPartnerMain';

function RouteAgent({
  component: Component,
  authType,
  missingBanking,
  pwResetRequired,
  token,
  expiry,
  ...rest
}) {

  //catch missing required props
  if(!authType || !token || !expiry) {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/partner/login", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //check expiry
  const currentDate = parseInt(new Date().getTime() / 1000);
  const expiryDate = parseInt(expiry);
  //check reducer store and local token values
  const validToken = (token === localStorage.getItem('token'))? true : false;
  const validDate = (currentDate < expiryDate)? true : false;

  return(
        <Route
          {...rest}
          render={props =>
              ((authType === 'AGENT' || authType === 'MANAGER') && validToken && validDate) ?
                (<React.Suspense fallback={<WrapperPartnerMain inSuspense={true}/>}>
                  <Component {...props} />
                </React.Suspense>) :
                (<Redirect to={{ pathname: "/partner/logout", state: {from: props.location} }} /> )
          }
        />
  );
}

export default RouteAgent;
